var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import React, { useEffect, useState } from "react";
import { Button, Card, Grid, GridColumn, RightDiv, Separator } from "@atlassiansox/microscopekit";
import { TaskGroupView } from "../TaskGroupView";
import SectionMessage from "@atlaskit/section-message";
import { TaskGroupFormFc } from "./TaskGroupFormFc";
import { useSendScreenEvent } from "../../analytics";
import { indexOf } from "lodash";
import { BaselinePanel } from "../Home/Baseline/BaselinePanel";
var TaskGroupFormWrapper = function (props) {
    var _a = __read(useState(props.wargameTemplate.taskGroup ? props.wargameTemplate.taskGroup : []), 2), taskGroups = _a[0], setTaskGroups = _a[1];
    var _b = __read(useState(false), 2), isEditMode = _b[0], setIsEditMode = _b[1];
    var _c = __read(useState(undefined), 2), taskGroupInEditMode = _c[0], setTaskGroupInEditMode = _c[1];
    var _d = __read(useState(undefined), 2), taskGroupInEditModeIndex = _d[0], setTaskGroupInEditModeIndex = _d[1];
    useEffect(function () {
        props.wargameTemplate.taskGroup = taskGroups;
        props.setIsFormValid(taskGroups.length > 0 && !isEditMode);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [taskGroups, isEditMode]);
    useSendScreenEvent("createWargamePlanTaskGroupDefinitionStep");
    var addTaskGroup = function (taskGroup) {
        var i = taskGroupInEditModeIndex !== null && taskGroupInEditModeIndex !== void 0 ? taskGroupInEditModeIndex : taskGroups.length;
        setTaskGroups(__spread(taskGroups.slice(0, i), [
            taskGroup
        ], taskGroups.slice(i)));
        setIsEditMode(false);
        setTaskGroupInEditMode(undefined);
        setTaskGroupInEditModeIndex(undefined);
    };
    var editTaskGroup = function (taskGroupToEdit) {
        // Remove the task group from taskGroups list
        var tmpTaskGroups = [];
        taskGroups.forEach(function (taskGroup) {
            if (taskGroupToEdit !== taskGroup) {
                tmpTaskGroups.push(taskGroup);
            }
        });
        setTaskGroups(tmpTaskGroups);
        // Set the task group to edit
        setTaskGroupInEditMode(taskGroupToEdit);
        setTaskGroupInEditModeIndex(indexOf(taskGroups, taskGroupToEdit));
        setIsEditMode(true);
    };
    var deleteTaskGroup = function (taskGroupToDelete) {
        var tmpTaskGroups = [];
        taskGroups.forEach(function (taskGroup) {
            if (taskGroupToDelete !== taskGroup) {
                tmpTaskGroups.push(taskGroup);
            }
        });
        setTaskGroups(tmpTaskGroups);
    };
    var cancelTaskGroupEdit = function () {
        if (taskGroupInEditMode) {
            addTaskGroup(taskGroupInEditMode);
        }
        setIsEditMode(false);
        setTaskGroupInEditMode(undefined);
        setTaskGroupInEditModeIndex(undefined);
    };
    var createTaskGroup = function () {
        setIsEditMode(true);
        setTaskGroupInEditModeIndex(taskGroups.length);
    };
    return (React.createElement("div", null,
        React.createElement("br", null),
        React.createElement(BaselinePanel, { baseline: props.baseline }),
        React.createElement("br", null),
        React.createElement(Grid, { layout: "flex" },
            React.createElement(GridColumn, { medium: 8 },
                React.createElement("h4", null, "Task Group List")),
            React.createElement(GridColumn, { medium: 4 },
                React.createElement(RightDiv, null,
                    React.createElement("div", { hidden: isEditMode },
                        React.createElement(Button, { appearance: "primary", onClick: createTaskGroup }, "Create task group"))))),
        React.createElement("br", null),
        React.createElement(SectionMessage, null, "The faults will be executed in the order listed here"),
        React.createElement(Separator, null),
        taskGroups.map(function (taskGroup, index) { return (React.createElement(TaskGroupView, { taskGroup: taskGroup, index: index, editFc: editTaskGroup, deleteFc: deleteTaskGroup, key: "TaskGroupView" + index, isCollapsedInitially: isEditMode || index !== taskGroups.length - 1 })); }),
        React.createElement(Card, { hidden: taskGroups.length !== 0 }, "No task groups"),
        React.createElement(Separator, null),
        isEditMode && (React.createElement(TaskGroupFormFc, { containersForService: props.containersForService, microsGroupsForService: props.microsGroupsForService, addTaskGroup: addTaskGroup, cancelTaskGroupEdit: cancelTaskGroupEdit, taskGroup: taskGroupInEditMode, taskGroupIndex: taskGroupInEditModeIndex, serviceId: props.serviceId, environment: props.environment }))));
};
export default TaskGroupFormWrapper;
